/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */

import { Interweave } from "interweave";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getExerciseLevelsData,
  updateExerciseLevel,
} from "../../../actions/user_program";
import ChangeLevelModal from "../../Layout/ChangeLevelModal";
import GeneralModal from "./GeneralModal";
import { CommonPageData } from "../../../styles/common.style";

const CompiledChangeLevel = ({
  exerciseId,
  curLevel,
  activeId,
  programId,
  compilationVideoId,
  exercisesLevels,
  getExerciseLevelsData,
  weekSchedule,
  updateExerciseLevel,
  levelUpdate,
  levelUpdateSuccess,
  redirectLink,
}) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [level, setLevel] = useState(null);
  const [showStartModal, setShowStartModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [modalTitle, setModalTitle] = useState();

  const [exerciseLevelsData, setExerciseLevelsData] = useState([]);
  const [exerciseLevel1Equipments, setExerciseLevel1Equipments] = useState([]);
  const [exerciseLevel2Equipments, setExerciseLevel2Equipments] = useState([]);
  const [exerciseLevel3Equipments, setExerciseLevel3Equipments] = useState([]);
  useEffect(() => {
    // Fallback to exerciseId if compilationVideoId is null

    const idToUse = compilationVideoId || exerciseId;
    if (idToUse && curLevel) {
      getExerciseLevelsData(idToUse);
    }
  }, [compilationVideoId, exerciseId, curLevel]);

  useEffect(() => {
    setExerciseLevelsData([]);
    setExerciseLevel1Equipments([]);
    setExerciseLevel2Equipments([]);
    setExerciseLevel3Equipments([]);

    if (exercisesLevels?.level1 && exercisesLevels.level1.length > 0) {
      if (exercisesLevels.level1[0].equipment_no == 0) {
        setExerciseLevelsData((exerciseLevelsData) => [
          ...exerciseLevelsData,
          exercisesLevels.level1[0],
        ]);
        setExerciseLevel1Equipments((exerciseLevel1Equipments) =>
          exercisesLevels.level1.filter((_, index) => index !== 0)
        );
      } else {
        setExerciseLevel1Equipments(
          (exerciseLevel1Equipments) => exercisesLevels.level1
        );
      }
    }
    if (exercisesLevels?.level2 && exercisesLevels.level2.length > 0) {
      if (exercisesLevels.level2[0].equipment_no == 0) {
        setExerciseLevelsData((exerciseLevelsData) => [
          ...exerciseLevelsData,
          exercisesLevels.level2[0],
        ]);
        setExerciseLevel2Equipments((exerciseLevel2Equipments) =>
          exercisesLevels.level2.filter((_, index) => index !== 0)
        );
      } else {
        setExerciseLevel2Equipments(
          (exerciseLevel2Equipments) => exercisesLevels.level2
        );
      }
    }
    if (exercisesLevels?.level3 && exercisesLevels.level3.length > 0) {
      if (exercisesLevels.level3[0].equipment_no == 0) {
        setExerciseLevelsData((exerciseLevelsData) => [
          ...exerciseLevelsData,
          exercisesLevels.level3[0],
        ]);
        setExerciseLevel3Equipments((exerciseLevel3Equipments) =>
          exercisesLevels.level3.filter((_, index) => index !== 0)
        );
      } else {
        setExerciseLevel3Equipments(
          (exerciseLevel3Equipments) => exercisesLevels.level3
        );
      }
    }
  }, [exercisesLevels]);

  const changeLevelFunc = (data) => {
    setLevel(data);
    handleShow();
  };

  const changeLevelModal = (data, title) => {
    setModalTitle(title);
    setModalData(data);
    setShowStartModal(true);
  };
  const setShowStartFunc = (data) => {
    setShowStartModal(data);
  };

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleSubmit = () => {
    if (level && exerciseId) {
      updateExerciseLevel(activeId, exerciseId, level);
    }
  };

  if (levelUpdateSuccess && levelUpdate) {
    dispatch({ type: "LEVEL_CHANGE_PURGE" });
    if (
      redirectLink !== null &&
      redirectLink !== undefined &&
      redirectLink !== ""
    ) {
      navigate(`${redirectLink}`, {
        replace: true,
        state: { myData: activeId },
      });
    } else {
      navigate(`/program/${programId}`, { replace: true });
    }
  }

  const ReadMoreP = ({ text, maxLength, className }) => {
    const [expanded, setExpanded] = useState(false);
    const truncatedText = text?.slice(0, maxLength);
    return (
      <div>
        <div className={`titles-label ${className}`}>
          <Interweave content={expanded ? text : truncatedText} />
        </div>
      </div>
    );
  };

  const handleClick = () => {
    if (
      redirectLink !== null &&
      redirectLink !== undefined &&
      redirectLink !== ""
    ) {
      navigate(`${redirectLink}`, {
        replace: true,
        state: { myData: activeId },
      });
    } else {
      navigate(`/program/${programId}`, { replace: true });
    }
  };

  const StartingPosition = () => {
    return (
      <div className={"ViewModalContact"}>
        <div>
          <div className={`titles-label`}>
            <Interweave content={modalData} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <CommonPageData>
        <div className="common-banner-block">
          <div className="main-banner">
            <img src="/images/banner-common-block.png" alt="img" />
          </div>
          <div className="container">
            <div className="common-banner-block-inner">
              <h1>Change Movement</h1>
            </div>
          </div>
        </div>
        <section className="change-block">
          <div className="container">
            {exerciseLevelsData.length !== 0 && (
              <>
                <div className="top-block">
                  <h2 className="title-inner-block">
                    <span>Choose</span> a movement to perform instead
                  </h2>
                  <button
                    onClick={() => handleClick()}
                    type="button"
                    className="common-btn-all-front min-auto-btn  btn btn-primary"
                  >
                    Back
                  </button>
                </div>
                <div className="middle-text-block">
                  <p>
                    If you select an exercise, it will replace the original
                    exercise in your program.<br></br> You can change the
                    exercise levels at any time.
                  </p>
                </div>
              </>
            )}
            {exerciseLevelsData.length == 0 && (
              <>
                <div className="col-12 col-md-12 col-lg-12 mb-3" id="checknew">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-12">
                      <p className={"text-center"}>
                        No levels options available for selected exercise
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-12 col-md-12 col-sm-12 level01  text-center">
                  <div className="position-relative">
                    <button
                      type="button"
                      className="common-btn-all-front min-auto-btn  btn btn-primary"
                      onClick={handleClick}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </>
            )}
            <div className="change-level-block">
              {exerciseLevelsData.length > 0 &&
                exerciseLevelsData.map((item, index) => (
                  <>
                    <div
                      key={index}
                      className="change-level-block-inner"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/program/change-levels/details`, {
                          replace: true,
                          state: {
                            levelData: item,
                            activeId: activeId,
                            programId: programId,
                          },
                        })
                      }
                    >
                      <div className="box-changes">
                        <h3>Level {item?.level}</h3>
                        <div className="img-change-block">
                          <img
                            src={item?.exerciseLevel?.video_cover}
                            alt="img"
                          />
                        </div>
                        <p>{item?.exerciseLevel?.file_name}</p>
                      </div>
                    </div>
                  </>
                ))}
            </div>

            <div className="equipment-block">
              <h2 className="title-inner-block">
                <span>EQUIPMENT</span> OPTIONS
              </h2>
              <div>
                {exerciseLevel1Equipments.length === 0 &&
                exerciseLevel2Equipments.length === 0 &&
                exerciseLevel3Equipments.length === 0 ? (
                  <h5 className="red-title">No Equipment.</h5>
                ) : (
                  ""
                )}
              </div>
              {exerciseLevel1Equipments?.length > 0 && (
                <div className="equipment-block-inner">
                  {exerciseLevel1Equipments.map((item, index) => (
                    <>
                      <div
                        className="equipment-block-flex"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/program/change-levels/details`, {
                            replace: true,
                            state: { levelData: item, activeId: activeId, programId: programId },
                          })
                        }
                      >
                        <div className="img-equipment">
                          <img
                            src={item?.exerciseLevel?.video_cover}
                            alt="img"
                          />
                        </div>
                        <p>{item?.exerciseLevel?.file_name}</p>
                      </div>
                    </>
                  ))}
                </div>
              )}
              {exerciseLevel2Equipments?.length > 0 && (
                <div className="equipment-block-inner">
                  {exerciseLevel2Equipments.map((item, index) => (
                    <>
                      <div
                        className="equipment-block-flex"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/program/change-levels`, {
                            replace: true,
                            state: { levelData: item, activeId, programId },
                          })
                        }
                      >
                        <div className="img-equipment">
                          <img
                            src={item?.exerciseLevel?.video_cover}
                            alt="img"
                          />
                        </div>
                        <p>{item?.exerciseLevel?.file_name}</p>
                      </div>
                    </>
                  ))}
                </div>
              )}

              {exerciseLevel3Equipments?.length > 0 && (
                <div className="equipment-block-inner">
                  {exerciseLevel3Equipments.map((item, index) => (
                    <>
                      <div
                        className="equipment-block-flex"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/program/change-levels/details`, {
                            replace: true,
                            state: { levelData: item, activeId, programId },
                          })
                        }
                      >
                        <div className="img-equipment">
                          <img
                            src={item?.exerciseLevel?.video_cover}
                            alt="img"
                          />
                        </div>
                        <p>{item?.exerciseLevel?.file_name}</p>
                      </div>
                    </>
                  ))}
                </div>
              )}
            </div>
          </div>
        </section>
        <GeneralModal
          title={modalTitle}
          show={showStartModal}
          onHide={() => setShowStartFunc(false)}
          size={"md"}
          content={<StartingPosition />}
        />
        <ChangeLevelModal
          handleClose={handleClose}
          show={show}
          handleSubmit={handleSubmit}
        />
      </CommonPageData>
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  exerciseLevelsRequest: state.programReducer.exerciseLevelsRequest || null,
  exerciseLevelsSuccess: state.programReducer.exerciseLevelsSuccess || null,
  exerciseLevelsFailure: state.programReducer.exerciseLevelsFailure || null,
  exercisesLevels: state.programReducer.exercisesLevels,

  levelUpdateRequest: state.programReducer.levelUpdateRequest || null,
  levelUpdateSuccess: state.programReducer.levelUpdateSuccess || null,
  levelUpdateFailure: state.programReducer.levelUpdateFailure || null,
  levelUpdate: state.programReducer.levelUpdate,
  ownProps: ownProps,
});

export default connect(mapStateToProps, {
  getExerciseLevelsData,
  updateExerciseLevel,
})(CompiledChangeLevel);
